import React from "react";
import { useNavigate } from "react-router-dom";
import dummyData from "../../Utilities/dummyData";
import "./DropdownMenu.css";

const DropdownMenu = () => {
  const navigate = useNavigate();

  const handleSubjectClick = (subject) => {
    // You can pass subject via state or query if needed
    navigate("/courses");
  };

  return (
    <div className="dropdown-container">
      <ul className="dropdown-menu">
        {dummyData.map((edu, idx) => (
          <li key={idx} className="dropdown-item">
            <span>{edu.title}</span>
            <ul className="submenu class-menu">
              {edu.classes.map((cls, cIdx) => (
                <li key={cIdx} className="dropdown-item">
                  <span>{cls.title}</span>
                  <ul className="submenu subject-menu">
                    {cls.subjects.map((subj, sIdx) => (
                      <li
                        key={sIdx}
                        className="dropdown-item"
                        onClick={() => handleSubjectClick(subj)}
                      >
                        {subj}
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DropdownMenu;
